import { render, staticRenderFns } from "./FeedbackDisplay.vue?vue&type=template&id=5c202e98&scoped=true"
import script from "./FeedbackDisplay.vue?vue&type=script&lang=js"
export * from "./FeedbackDisplay.vue?vue&type=script&lang=js"
import style0 from "./FeedbackDisplay.vue?vue&type=style&index=0&id=5c202e98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c202e98",
  null
  
)

export default component.exports